import { useTheme } from "../hooks/useTheme";

export default function ThemeToggle() {
    const { theme, toggle } = useTheme();
    const isDark = theme === "dark";

    return (
        <button
            type="button"
            onClick={toggle}
            className={`theme-toggle theme-toggle--${theme}`}
            aria-label={isDark ? "Light Mode aktivieren" : "Dark Mode aktivieren"}
            title={isDark ? "Light Mode" : "Dark Mode"}
        >
            <span className="theme-toggle__orbit" aria-hidden="true">
                <svg
                    className="theme-toggle__sun"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    aria-hidden="true"
                >
                    <circle cx="12" cy="12" r="4.5" />
                    <path d="M12 2v2.5M12 19.5V22M4.93 4.93l1.77 1.77M17.3 17.3l1.77 1.77M2 12h2.5M19.5 12H22M4.93 19.07l1.77-1.77M17.3 6.7l1.77-1.77" />
                </svg>
                <svg
                    className="theme-toggle__planet"
                    viewBox="0 0 32 32"
                    aria-hidden="true"
                >
                    <ellipse
                        cx="16"
                        cy="16"
                        rx="13"
                        ry="3.5"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="1.6"
                        transform="rotate(-22 16 16)"
                    />
                    <circle cx="16" cy="16" r="6.5" fill="currentColor" />
                </svg>
            </span>
        </button>
    );
}
